import PortalLearningPath from '@classes/LearningPath'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import WithLearningPathContext, { WithLearningPathContextProps } from '@hocs/WithLearningPathContext'
import Chapter from '@layouts/LearningPath/Chapter'
import FlexChapter from '@layouts/LearningPath/Chapter/Flex'
import { TileCol } from '@layouts/LearningPath/Layout/style'
import React from 'react'

export interface PanelTileProps {
  Unit: PortalLearningPathUnit
  Path: PortalLearningPath
  children?: React.ReactNode
}

const PanelTile: React.FC<PanelTileProps & WithLearningPathContextProps> = ({
  Unit,
  Path,
  active,
  activeHover,
  setActive,
  setActiveHover,
  setPlayVideo,
  children,
}) => {
  return (
    <TileCol id={`tile-${Unit.Id}-${Unit.LearningPathId}`} key={Unit.Id}>
      <div
        onClick={() => setActive(Unit.Id)}
        onMouseEnter={() => !activeHover && setActiveHover(Unit.Id)}
        onMouseLeave={() => activeHover && setActiveHover(0)}
      >
        {children ? (
          children
        ) : Path.IsFlex ? (
          <FlexChapter Unit={Unit} active={Boolean(active)} Path={Path} />
        ) : (
          <Chapter setPlayVideo={setPlayVideo} active={Boolean(active)} Unit={Unit} />
        )}
      </div>
    </TileCol>
  )
}

export default WithLearningPathContext(React.memo(PanelTile))
